import React, { useEffect, useRef, useState } from "react";
import DetailsForm from "./DetailsForm";
import {
  Buyer_Agent_Offer,
  Buyer_OFFER,
  BuyerAgent_Optional,
} from "./formState";
import {
  getBidDepositContigencyCash,
  getBidDepositContigencyMortgage,
} from "@/api/bidDepositApiHold";
import { checkDeletedUserEmail, getAllLicenseDetails, verifyLicenseDetails } from "@/api/myProfile";
import { AgentLiecenseErrorMsgs } from "@/setting";
import { isInternal } from "@/api/offers";
import LicenseErrorPopup from "./LicenseErrorPopup";
import { trackButtonClick } from "@/utils/analytics";

const BuyerAgentInformation = ({
  accordionState,
  bidUserDetail,
  preOfferCifEnabledFlag,
  bidQuestionariesEnabled,
  isAgent,
  defaultState,
  setContigency,
  defaultPaymentType,
  listingId,
  bidAmount,
  setOfferUserDetail,
  offerDetails,
  setOfferDetails,
  setAgent,
  setAccordionState,
  stateByName,
  cifDataDocuments,
  individualLicenseStateCif,
  offerType
}) => {
  const [buyer, setBuyer] = useState(
    isAgent || isAgent === "Yes" ? "No" : "Yes"
  );
  const licensedRef = useRef(null);

  const [touredProperty, setTouredProperty] = useState("Yes");
  const [occupyThemselves, setOccupyThemselves] = useState("");
  const [licensed, setLicensed] = useState("");
  const [buyerData, setBuyerData] = useState({
    firstName: "",
    lastName: "",
    emailId: "",
    phone: "",
  });
  const [buyerAgentData, setBuyerAgentData] = useState({});
  const [disabledFields, setDisabledFields] = useState([]);
  const [mandatoryAgentFields, setMandatoryAgentFields] = useState([]);
  const [mandatoryBuyerFields, setMandatoryBuyerFields] = useState([]);
  const [disable, setDisable] = useState(true);
  const [error, setError] = useState("");
  const [buyerFormErrors, setBuyerFormErrors] = useState({});
  const [agentFormErrors, setAgentFormErrors] = useState({});
  const buyerFormRef = useRef();
  const agentFormRef = useRef();
  const [isBuyerAgentDataAvailable, setIsBuyerAgentDataAvailable] =
    useState(false);
  const [dropErros, setDropErrors] = useState({});
  const [indvLicenseDetails, setIndvLicenseDetails] = useState({});
  const [licenseState, setLicenseState] = useState("");
  const [show,setShow] = useState(false);
  const [msg,setMsg] = useState("")
  const lastBuyerDataRef = useRef();
const lastBuyerAgentDataRef = useRef();
const [loading,setLoading] = useState(false);



  const renderDetailsForm = (
    title,
    stateData,
    disableFields,
    fields,
    isOptional,
    setStateData,
    mandatoryFields,
    onErrorChange,
    formRef,
     errors
  ) => (
    <div className="col-sm-12 col-md-6 buyerform">
      <h6 className="mb-1 mb-sm-5 form-title-buyeragent">
        {title} <span className="optional">{isOptional && "(Optional)"}</span>
      </h6>
      <DetailsForm
        disableAllFields={disableFields}
        fields={fields}
        stateData={stateData}
        setStateData={setStateData}
        mandatoryFields={mandatoryFields}
        setDisable={setDisable}
        onErrorChange={onErrorChange}
        ref={formRef}
        errors={errors}
        licenseState={licenseState}
        setLicenseState={setLicenseState}
      />
    </div>
  );

  useEffect(() => {
    setBuyer(isAgent || isAgent === "Yes" ? "No" : "Yes");
    getLicenseDetailsForAgent();
  }, [isAgent]);
    // added to check the value in server
  // console.log(stateByName,'state name',indvLicenseDetails,buyerAgentData);

    useEffect(() => {
      const defaultBuyerData = {
        firstName:
          bidUserDetail?.buyerDetail?.firstName || buyerData?.firstName || "",
        lastName:
          bidUserDetail?.buyerDetail?.lastName || buyerData?.lastName || "",
        emailId: bidUserDetail?.buyerDetail?.emailId || buyerData?.emailId || "",
        phone: bidUserDetail?.buyerDetail?.phone || buyerData?.phone || "",
      };
      const defaultBuyerDataAgent = {
        firstName: buyerAgentData?.firstName || bidUserDetail?.agentDetail?.firstName || "",
        lastName:buyerAgentData?.lastName || bidUserDetail?.agentDetail?.lastName || "",
        emailId: buyerAgentData?.emailId ||bidUserDetail?.agentDetail?.emailId || "",
        phone:buyerAgentData?.phone || bidUserDetail?.agentDetail?.phone || "",
      };

      if (preOfferCifEnabledFlag) {
        setBuyerData(defaultBuyerData);
        if (cifDataDocuments?.buyerAgent) {
          if (
            Object.keys(cifDataDocuments).length > 0 &&
            Object.keys(cifDataDocuments?.buyerAgent).length > 0
          ) {
            if (isAgent || isAgent === "Yes") {
              setBuyerAgentData({
                firstName: cifDataDocuments?.buyerAgent?.firstName,
                lastName: cifDataDocuments?.buyerAgent?.lastName,
                emailId: cifDataDocuments?.buyerAgent?.email,
                phone: cifDataDocuments?.buyerAgent?.phone,
                companyName: cifDataDocuments?.buyerAgent?.company,
                state: individualLicenseStateCif || stateByName || indvLicenseDetails?.stateName,
                licenceNumber: indvLicenseDetails?.licenseNumber || cifDataDocuments?.buyerAgent?.individualLicenseNumber || "",
                licenseExpirationDateString: indvLicenseDetails?.expiryDate || cifDataDocuments?.buyerAgent?.licenseExpiryDate || "",
              });
              setLicenseState(
                indvLicenseDetails?.status === "LCNS_PEND"
                  ? "Verification Pending"
                  : ""
              );
            } else {
              setBuyerAgentData({
                firstName: cifDataDocuments?.buyerAgent?.firstName,
                lastName: cifDataDocuments?.buyerAgent?.lastName,
                emailId: cifDataDocuments?.buyerAgent?.email,
                phone: cifDataDocuments?.buyerAgent?.phone,
                companyName: cifDataDocuments?.buyerAgent?.company,
                state: individualLicenseStateCif || stateByName,
              });
              setMandatoryAgentFields([]);
            }
            if (Object.keys(cifDataDocuments?.buyer).length > 0) {
              setBuyerData({
                firstName: cifDataDocuments?.buyer?.firstName,
                lastName: cifDataDocuments?.buyer?.lastName,
                emailId: cifDataDocuments?.buyer?.email,
                phone: cifDataDocuments?.buyer?.phone,
              });
            }
            if (individualLicenseStateCif?.length === 0) {
              setDisabledFields(["firstName", "lastName", "emailId", "phone"]);
            } else {
              setDisabledFields([
                "firstName",
                "state",
                "lastName",
                "emailId",
                "phone",
              ]);
            }
          }
        }
        if (cifDataDocuments?.buyer) {
          if (Object.keys(cifDataDocuments?.buyer).length > 0) {
            setBuyerData({
              firstName: cifDataDocuments?.buyer?.firstName,
              lastName: cifDataDocuments?.buyer?.lastName,
              emailId: cifDataDocuments?.buyer?.email,
              phone: cifDataDocuments?.buyer?.phone,
            });
          }
          if (individualLicenseStateCif?.length === 0) {
            setDisabledFields(["firstName", "lastName", "emailId", "phone"]);
          } else {
            setDisabledFields([
              "firstName",
              "state",
              "lastName",
              "emailId",
              "phone",
            ]);
          }
        }
        setMandatoryBuyerFields(["firstName", "lastName", "emailId", "phone"]);
        if (cifDataDocuments?.representedByAgent === "Y" && buyer !== "Yes") {
          setMandatoryAgentFields([
            "firstName",
            "lastName",
            "emailId",
            "phone",
            "companyName",
            "licenceNumber",
            "state",
            "licenseExpirationDateString",
          ]);
        } else {
          setMandatoryAgentFields([]);
        }
        // setDisabledFields(["firstName", "lastName", "emailId", "phone"]);
      } else if (buyer === "Yes") {
        setBuyerData(
          isAgent === "Yes" || isAgent
            ? {
                firstName:
            buyerAgentData?.firstName ||bidUserDetail?.agentDetail?.firstName ||
                  "",
                lastName:
                buyerAgentData?.lastName ||   bidUserDetail?.agentDetail?.lastName ||
              "",
                emailId:
                  buyerAgentData?.emailId || bidUserDetail?.agentDetail?.emailId || "",
                phone:
                buyerAgentData?.phone ||  bidUserDetail?.agentDetail?.phone || "",
              }
            : {
                firstName:
                buyerData?.firstName ||   bidUserDetail?.buyerDetail?.firstName ||

                  "",
                lastName:
                  buyerData?.lastName || bidUserDetail?.buyerDetail?.lastName ||

                  "",
                emailId:
                  buyerData?.emailId || bidUserDetail?.buyerDetail?.emailId || "",
                phone:
                buyerData?.phone ||   bidUserDetail?.buyerDetail?.phone || "",
              }
        );
        setBuyerAgentData({
          firstName: "",
          lastName: "",
          phone: "",
          emailId: "",
          companyName: "",
        });
        setDisabledFields(["emailId"]);
        setMandatoryBuyerFields(["firstName", "lastName", "emailId", "phone"]);
        setMandatoryAgentFields([]);
      } else if (buyer === "No") {
        const encodedString = bidUserDetail?.agentDetail?.companyName || "";
        const decodedString = new DOMParser().parseFromString(
          encodedString,
          "text/html"
        ).body.textContent;
        if (isAgent === "Yes" || isAgent) {
             setMandatoryBuyerFields(["firstName", "lastName", "emailId", "phone"]);
          setBuyerAgentData({

            ...defaultBuyerDataAgent,
            companyName: decodedString || "",
            licenceNumber: indvLicenseDetails?.licenseNumber || "",
            state: individualLicenseStateCif || stateByName || "",
            licenseExpirationDateString: indvLicenseDetails?.expiryDate ||"",
          });
          setLicenseState(
                indvLicenseDetails?.status === "LCNS_PEND"
                  ? "Verification Pending"
                  : ""
              );
        } else {

          setBuyerAgentData({
            ...defaultBuyerData,
            companyName: decodedString || "",
            licenceNumber: "",
            state: individualLicenseStateCif || stateByName || "",
            licenseExpirationDateString:"",
          });
        }
        setBuyerData({ firstName: "", lastName: "", phone: "", emailId: "" });
        setDisabledFields(["emailId", "state"]);
        setMandatoryAgentFields([
          "firstName",
          "lastName",
          "emailId",
          "phone",
          "companyName",
          "licenceNumber",
          "state",
          "licenseExpirationDateString",
        ]);
      }
    }, [
      bidUserDetail,
      preOfferCifEnabledFlag,
      buyer,
      cifDataDocuments,
      individualLicenseStateCif,
      indvLicenseDetails,stateByName
    ]);
    useEffect(()=>{
       getLicenseDetailsForAgent();
    },[individualLicenseStateCif,stateByName,isAgent])


  const getLicenseDetailsForAgent = async () => {
    const data = await getAllLicenseDetails();

    if (data?.response?.INDV?.length > 0) {
      const matchedINDV = data?.response?.INDV?.filter(
        (item) =>
          item?.stateName === individualLicenseStateCif ||
          item?.stateName === stateByName
      );
      if (matchedINDV?.length > 0) {
        setIndvLicenseDetails(matchedINDV?.[0]);
      }
      // setIndvLicenseDetails(data?.response?.INDV?.[data?.response?.INDV?.length-1])
    } else {
      setIndvLicenseDetails(data?.response?.INDV?.[0]);
    }
  };
  const handleBuyerDataChange = (updatedData) => {
  setBuyerData(updatedData);
  lastBuyerDataRef.current = updatedData;
};

const handleBuyerAgentDataChange = (updatedData) => {
  setBuyerAgentData(updatedData);
  lastBuyerAgentDataRef.current = updatedData;
};

const handleClose = () =>{
  setShow(false)
  setMsg("")
}
  const getBidContigencyDetails = async () => {
    try {
      const details = await verifyLicenseDetails(
        buyerAgentData?.licenseNumber || "",
        defaultState
      );

      if( buyerAgentData?.licenseNumber?.length>0 &&( details?.verificationStatus !=="LICENSE_FORMAT_OK" && details?.verificationStatus !== "LICENSE_FORMAT_NOT_ACTIVE")){
        setAgentFormErrors({...agentFormErrors,licenseNumber:"Invalid License"})
        const msg = AgentLiecenseErrorMsgs[details?.jurisdictName]
        let popupMsg = `Please Note : ${msg}`
        setMsg(popupMsg);
        setShow(true)
        setLoading(false)
        // alert(`Please Note : ${msg}`)
        return false;
      }
        const encodedEmail = encodeURIComponent(buyerData?.emailId);
      const queryString = `emailId=${encodedEmail}`;
      const isDeletedData = await checkDeletedUserEmail(queryString)
      const internalUser = await isInternal({email:buyerData?.emailId})

      if(isDeletedData?.data?.data){
        setError(" The account associated with the given email address is marked for deletion. Please provide a different email address.")
        setLoading(false)
        return false;
      }

      if (defaultPaymentType === "CASH") {
        const data = await getBidDepositContigencyCash(listingId, bidAmount);
        setContigency(data.data);

      } else {
        const data = await getBidDepositContigencyMortgage(
          listingId,
          bidAmount
        );
        setContigency(data.data);
      }
      return true;
    } catch (error) {
      console.log(error);
      return false
    }
  };

  const continueToFinance = async() => {
    setLoading(true)
    const newErrors = {};
    const buyerErrors = buyerFormRef.current?.validateAllFields?.() || {};
    const agentErrors = agentFormRef.current?.validateAllFields?.() || {};

    setBuyerFormErrors(buyerErrors);
    setAgentFormErrors(agentErrors);

    if (bidQuestionariesEnabled && licensed?.length === 0) {
      newErrors.licensed = "Please select an option";
    }
    if (bidQuestionariesEnabled && occupyThemselves?.length === 0) {
      newErrors.occupyThemselves = "Please select an option";
    }
    setDropErrors(newErrors);

    const hasErrors =
      Object.values(buyerErrors).some((e) => e) ||
      Object.values(agentErrors).some((e) => e) ||
      Object.values(newErrors).some((e) => e);

    const hasEmailError =
      buyerData.emailId &&
      buyerAgentData.emailId &&
      buyerData.emailId === buyerAgentData.emailId;

    if (hasEmailError) {
      setError("Buyer and Agent email can not be same");
      setLoading(false)
      return;
    }

    if (hasErrors) {
       licensedRef.current?.focus();
      // setError("Please fix the errors above");
      setLoading(false)
      return;
    }

    if (buyerAgentData.firstName && !buyerAgentData.lastName) {
      setError("Please provide agent's last name");
      setLoading(false)
      return;
    }
    if (buyerAgentData.lastName && !buyerAgentData.firstName) {
      setError("Please provide agent's first name");
      setLoading(false)
      return;
    }
    const success = await getBidContigencyDetails();
  if (!success) return;

    // Proceed to next accordion
let licenseExpirationDate = null;

if (buyerAgentData?.licenseExpirationDateString) {
  const [month, day, year] = buyerAgentData.licenseExpirationDateString.split("/");
  const date = new Date(Date.UTC(year, month - 1, day));
  licenseExpirationDate = date.toISOString();
}


    setError("");
    setDropErrors({});
    setAgent(buyer === "Yes" ? false : true);
    setOfferUserDetail({
      buyerDetail: buyerData,
      agentDetail: buyerAgentData.firstName !== "" ? {...buyerAgentData,state:cifDataDocuments?.buyerAgent?.individualLicenseState||defaultState,licenseExpirationDate:licenseExpirationDate|| ""} : null,
    });
    setOfferDetails({
      ...offerDetails,
      intendToOccupy:bidQuestionariesEnabled? occupyThemselves === "Yes" ? "Y" : "N":null,
      holdActiveLicense:bidQuestionariesEnabled? licensed === "Yes" ? "Y" : "N":null,
      propertyTouredSelected: touredProperty === "Yes" ? "Y" : "N",
      buyerEmailId: buyerData.emailId,
    });
    setLoading(false)
    setAccordionState({
      ...accordionState,
      accordion2: { disable: false, close: true, edit: true },
      accordion3: { close: false, disable: false, edit: false },
    });
    trackButtonClick({
      eventName: "offer_information_next",
      eventSource: "Continue Button Click",
      eventCategory: "New-Offer Wizard",
      eventLabel: `UserType:${buyer === "Yes" ? "BUYER" : "AGENT"} | VisitedProperty: ${touredProperty === "Yes" ? "Y" : "N"} | Listing Id: ${listingId}`,
      eventParams: {
        offer_type: offerType === "PLACE_OFFER" ? "offer" : "backup_offer",
      },
    });
  };


useEffect(() => {
  setAgentFormErrors({});
  setBuyerFormErrors({});
  buyerFormRef.current?.resetValidation();
  agentFormRef.current?.resetValidation();

  // Restore buyer/agent data from refs
  if (buyer === "Yes" && lastBuyerDataRef.current) {
    setBuyerData(lastBuyerDataRef.current);
  }

  if (buyer === "No" && lastBuyerAgentDataRef.current) {
    setBuyerAgentData(lastBuyerAgentDataRef.current);
  }
}, [buyer]);

  useEffect(() => {
    if (cifDataDocuments?.buyerAgent) {
      setIsBuyerAgentDataAvailable(true);
    } else {
      setIsBuyerAgentDataAvailable(false);
    }
  }, [cifDataDocuments]);

  return (
    <div className="accordion-item mb-2 border rounded">
      <h2 className="accordion-header p-1" id="flush-heading-buyeragentinfo">
        <button
          className={`accordion-button ${
            accordionState?.accordion2?.close ? "collapsed" : ""
          } ${
            accordionState?.accordion2?.close &&
            accordionState?.accordion2?.edit
              ? "no-caret"
              : ""
          }`}
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#flush-collapse-buyeragentinfo"
          aria-expanded="false"
          id="acc5"
          aria-controls="flush-collapse-buyeragentinfo"
          disabled={accordionState?.accordion2?.disable}
        >
          {" "}
          <div className="d-flex w-100 justify-content-between align-items-center">
            <p className="d-flex align-items-center mb-0 offer-acc-title">
              {" "}
              <p className="accordion-number mb-0">2</p> Buyer/Agent Information{" "}
            </p>
            {accordionState?.accordion2?.edit && (
              <>
                <div>
                  <button
                    className="edit-accordion-offer"
                    onClick={() =>
                      setAccordionState({
                        ...accordionState,
                        accordion2: {
                          ...accordionState.accordion2,
                          edit: false,
                          close: false,
                        },
                        accordion3: {
                          ...accordionState.accordion3,
                          close: true,
                        },
                      })
                    }
                  >
                    <i className="fa fa-pencil"></i> Edit{" "}
                  </button>
                </div>
              </>
            )}
          </div>
        </button>
      </h2>
      {accordionState?.accordion2?.edit ? (
        <>
          <div className="offer-amount-edit-div">
            <div className="row">
              <div className="col">
                <p className="edit-offer-amount-title">Buyer</p>
                <p className="edit-offer-amount mb-0">
                  {buyerData?.firstName}
                  {buyerData?.lastName} | {buyerData.phone}
                </p>
                <p className="edit-offer-amount">{buyerData.emailId}</p>
              </div>
              {buyerAgentData?.firstName && (
                <div className="col">
                  <p className="edit-offer-amount-title">Buyer's Agent</p>
                  <p className="edit-offer-amount mb-0">
                    {buyerAgentData?.firstName}
                    {buyerAgentData?.lastName}{" "}
                    {buyerAgentData.phone && <> |{buyerAgentData.phone}</>}
                  </p>
                  <p className="offer-amount">{buyerAgentData.emailId}</p>
                </div>
              )}
            </div>
          </div>
        </>
      ) : (
        <div
          id="flush-collapse-buyeragentinfo"
          className={`accordion-collapse collapse ${
            accordionState?.accordion2?.close ? "" : "show"
          }`}
          aria-labelledby="flush-heading-buyeragentinfo"
          data-bs-parent="#accordionFlushExample"
        >
          <div className="accordion-body">
            <div className="buyeragentinfo">
              {!preOfferCifEnabledFlag && (
                <RadioButtonGroup
                  title="I am a"
                  options={[
                    { label: "Buyer", value: "Yes" },
                    { label: "Buyer's Agent", value: "No" },
                  ]}
                  selectedValue={buyer}
                  onChange={setBuyer}
                />
              )}
              <RadioButtonGroup
                title="Have you toured the property?"
                options={[
                  { label: "Yes", value: "Yes" },
                  { label: "No", value: "No" },
                ]}
                selectedValue={touredProperty}
                onChange={setTouredProperty}
                mandatory={true}
              />
              {bidQuestionariesEnabled && (
                <>
                  <div className="radio-buyeragent flex">
                    <label htmlFor="occupyThemselves" className="title-iam">
                      Is (are) the buyer(s) planning to occupy the property
                      themselves? <span className="mandatory">*</span>
                    </label>
                    <select
                    ref={licensedRef}
                      name=""
                      className={`closingselect ${
                        dropErros?.occupyThemselves?.length > 0
                          ? "border-error"
                          : ""
                      }`}
                      id="occupyThemselves"
                      value={occupyThemselves}
                      onChange={(e) => setOccupyThemselves(e.target.value)}
                      onBlur={(e) => {
                        if (e.target.value !== "") {
                          setDropErrors({ ...dropErros, occupyThemselves: "" });
                        }
                      }}
                    >
                      <option value="">Select</option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                    {dropErros?.occupyThemselves?.length > 0 && (
                      <p className="error-offer">
                        {dropErros?.occupyThemselves}
                      </p>
                    )}
                  </div>

                  <div className="radio-buyeragent flex">
                    <label htmlFor="licensed" className="title-iam">
                      Is (are) the buyer(s) currently a licensed real estate
                      agent or broker in any state?
                      <span className="mandatory">*</span>
                    </label>
                    <select
                    ref={licensedRef}
                      name=""
                      className={`closingselect ${
                        dropErros?.licensed?.length > 0 ? "border-error" : ""
                      }`}
                      id="licensed"
                      value={licensed}
                      onChange={(e) => setLicensed(e.target.value)}
                      onBlur={(e) => {
                        if (e.target.value !== "") {
                          setDropErrors({ ...dropErros, licensed: "" });
                        }
                      }}
                    >
                      <option value="">Select</option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                    {dropErros?.licensed?.length > 0 && (
                      <p className="error-offer">{dropErros?.licensed}</p>
                    )}
                  </div>
                </>
              )}
              <div className="details row mt-4">
                {/* <div className="col-sm-12 col-md-6"> */}
                {renderDetailsForm(
                  "Buyer",
                  buyerData,
                  preOfferCifEnabledFlag
                    ? disabledFields
                    : buyer === "Yes"
                    ? disabledFields
                    : [],
                  Buyer_OFFER,
                  null,
                  setBuyerData,
                  mandatoryBuyerFields,
                  setBuyerFormErrors,
                  buyerFormRef,
                  buyerFormErrors
                )}
                {(!preOfferCifEnabledFlag || isBuyerAgentDataAvailable) &&
                  renderDetailsForm(
                    "Agent",
                    buyerAgentData,
                    buyer === "Yes" && !isBuyerAgentDataAvailable
                      ? []
                      : disabledFields,
                    buyer === "Yes" ? BuyerAgent_Optional : Buyer_Agent_Offer,
                    buyer === "Yes" ? true : null,
                    handleBuyerAgentDataChange,
                    mandatoryAgentFields,
                    setAgentFormErrors,
                    agentFormRef,
                    agentFormErrors
                  )}
              </div>
              {error.length > 0 && <p className="error-offer">{error}</p>}
            </div>

            <button
              // disabled={disable}
              onClick={continueToFinance}
              className="continue-offer btn btn-primary"
            >
              {
                loading?"Continue...":"Continue"
              }
            </button>
          </div>
        </div>
      )}
      {
        show && <LicenseErrorPopup handleClose={handleClose} msg={msg} show={show}/>
      }
    </div>
  );
};
export default BuyerAgentInformation;

const RadioButtonGroup = ({
  title,
  options,
  selectedValue,
  onChange,
  mandatory,
}) => {
  return (
    <div className="radio-buyeragent flex">
      <p className="title-iam">
        {title} {mandatory && <span className="mandatory">*</span>}
      </p>
      <div className="flex-radio">
        {options.map(({ label, value }) => (
          <>
            <input
              className="form-check-input "
              type="radio"
              name={title.toLowerCase().replace(" ", "")}
              id={`${value}-option`}
              value={value}
              checked={selectedValue === value}
              onChange={() => onChange(value)}
            />
            <label
              className="form-check-label iam-radio pt-1"
              htmlFor={`${value}-option`}
            >
              {label}
            </label>
          </>
        ))}
      </div>
    </div>
  );
};
